/**
 * Created by Wojciech Szydlak on 28.02.2018.
 */

namespace Entity.Map.Marker.Decorator {
    export class Orientation extends Decorator {

        protected _circle: google.maps.Circle;

        constructor(marker: Entity.Map.Marker.Marker, latLng: google.maps.LatLng, map: google.maps.Map) {
            super(marker, latLng, map);

            this.initCircle();
            this.append();
        }

        private initCircle() {
            const circle = new google.maps.Circle({
                map: this._map,
                center: this._latLng,
                strokeOpacity: 0.5,
                strokeWeight: 2,
                radius: 10
            });

            circle.addListener('click', (params) => {
                google.maps.event.trigger(this._map, 'click', params);
            });

            circle.addListener('rightclick', (params) => {
                google.maps.event.trigger(this._map, 'rightclick', params);
            });

            circle.addListener('dragstart', (params) => {
                google.maps.event.trigger(this._map, 'dragstart', params);
            });

            circle.addListener('dragend', (params) => {
                google.maps.event.trigger(this._map, 'dragend', params);
            });

            circle.addListener('idle', (params) => {
                google.maps.event.trigger(this._map, 'idle', params);
            });

            this._circle = circle;
        }

        setMap(map: google.maps.Map | null) {
            super.setMap(map);
            this._circle.setMap(map);
        }

        setVisible(visible: boolean) {
            super.setVisible(visible);
            this._circle.setVisible(visible);
        }

        public setPosition(latLng: google.maps.LatLng) {
            super.setPosition(latLng);
            this._circle.setCenter(latLng);
        }
    }
}